<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.留言板管理") }}</span>
    </div>
    <div style="overflow-y:auto;height: 58vh;width: 550px;">
      <!--父级-->
      <div class="grid-content content-margin" v-for="item in messageList" :key="item.currentNode.id">
        <div :id="item.currentNode.id" @click="selectDiv(item.currentNode)">
            <el-image
                  style="width:35px; height: 35px; border-radius: 50%;float:left;margin-top: 0px;margin-left: 0px;"
                  :src="item.currentNode.avatarUrl"
                  :fit="cover">
            </el-image>
          <div style="display:inline-block;margin-top: 8px;margin-left: 8px;width: 70%;">
            <div>
              <p style="display:inline-block;font-size:14px">
                {{item.currentNode.userName}}
              </p>
              <el-tag size="mini" type="success" color="#7FFFAA" v-show="item.currentNode.admin">管理员</el-tag>
              <el-tag size="mini" effect="dark" type="danger" v-show="item.currentNode.forbiddenFlag">禁言</el-tag>
              <el-tag size="mini" effect="dark" type="success" v-show="!item.currentNode.locked">锁帖</el-tag>
              <el-tag size="mini" effect="plain" type="danger" v-show="item.currentNode.sort==255">置顶</el-tag>
            </div>
            <p style="font-size:12px;margin-top: 10px;width: auto;height: auto;word-wrap: break-word;word-break: break-all;">{{item.currentNode.content}}</p>
            <div style="margin-top: 10px;width: 450px;">
              <p style="display:inline-block">{{formatDate(item.currentNode.createDate)}}</p>
              <p style="display:inline-block;margin-left: 10px;" v-show="item.currentNode.state==1">已过审</p>
              <p style="display:inline-block;margin-left: 10px;color:red" v-show="item.currentNode.state==0">未审核</p>
              <p style="display:inline-block;margin-left: 10px;color:grey" v-show="item.currentNode.state==2">已隐藏</p>
              <div style="display:inline-block;float:right;width: 135px;">
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="danger" v-show="!item.currentNode.forbiddenFlag" @click="forbiddenUser(item.currentNode.userID,1)">禁言</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="danger" v-show="item.currentNode.forbiddenFlag" @click="forbiddenUser(item.currentNode.userID,0)">解除</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="danger" color="#DC143C" v-show="item.currentNode.state<2" @click="hideMessage(item.currentNode.id,1)">隐藏</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="warning" color="#FF8C00" v-show="!item.currentNode.state==2" @click="hideMessage(item.currentNode.id,0)">显示</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" color="#1E90FF" v-show="item.currentNode.state==0" @click="examineMessage(item.currentNode.id)">过审</el-tag>
              </div>
            </div>
          </div>
        </div>
        <!--子级-->
        <div style="overflow-y:hidden;height: auto;" v-show="item.childNodes!=null" v-for="it in item.childNodes" :key="it.id" :id="it.id" @click="selectDiv(it)">
            <el-image
                  style="width:35px; height: 35px; border-radius: 50%;float:left;margin-top: 0px;margin-left: 40px;"
                  :src="it.avatarUrl"
                  :fit="cover">
            </el-image>
          <div style="display:inline-block;margin-top: 8px;margin-left: 8px;width: 70%;">
            <div>
              <p style="display:inline-block;font-size:14px">
                {{it.userName}}
              </p>
              <el-tag size="mini" type="success" color="#7FFFAA" v-show="it.admin">管理员</el-tag>
              <el-tag size="mini" effect="dark" type="danger" v-show="it.forbiddenFlag">禁言</el-tag>
              <el-tag size="mini" effect="dark" type="success" v-show="!it.locked">锁帖</el-tag>
              <el-tag size="mini" effect="plain" type="danger" v-show="it.sort==255">置顶</el-tag>
            </div>
            <p style="font-size:12px;margin-top: 10px;width: auto;height: auto;word-wrap: break-word;word-break: break-all;">{{it.replyUserName==null?it.content:'回复 '+it.replyUserName+': '+it.content}}</p>
            <div style="margin-top: 10px;width: 410px;">
              <p style="display:inline-block">{{formatDate(it.createDate)}}</p>
              <p style="display:inline-block;margin-left: 10px;" v-show="it.state==1">已过审</p>
              <p style="display:inline-block;margin-left: 10px;color:red" v-show="it.state==0">未审核</p>
              <p style="display:inline-block;margin-left: 10px;color:grey" v-show="it.state==2">已隐藏</p>
              <div style="display:inline-block;float:right;width: 135px;">
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="danger" v-show="!it.forbiddenFlag" @click="forbiddenUser(it.userID,1)">禁言</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="danger" v-show="it.forbiddenFlag" @click="forbiddenUser(it.userID,0)">解除</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="danger" color="#DC143C" v-show="it.state<2" @click="hideMessage(it.id,1)">隐藏</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" type="warning" color="#FF8C00" v-show="!it.state==2" @click="hideMessage(it.id,0)">显示</el-tag>
                <el-tag size="mini" style="cursor:pointer" effect="dark" color="#1E90FF" v-show="it.state==0" @click="examineMessage(it.id)">过审</el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-left: 20px;margin-top:0px;width:600px">
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">显示类型</span>
          </td>
          <td>
            <el-select @change="selectChanged" v-model="currentType" placeholder="消息显示类型" size="mini" >
              <el-option v-for="(it,index) in selectarr" :key="index" :label="it.key" :value="it.value">
              </el-option>
            </el-select>
          </td>
        </tr>
      </table>
    </div>
    <div class="grid-content content-margin" style="margin-top:-5px">
        <el-input
                v-model="message.content"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                maxlength="200"
                placeholder=""
                style="width: 530px"
                show-word-limit
              >
              </el-input>
              
        <div class="buttonarea" style="margin-top:5px">
          <el-link :underline="false">
            <el-button size="medium" round @click="topMessage">
              {{ $t("message.切换置顶") }}
            </el-button>
          </el-link>
          <el-link :underline="false">
            <el-button size="medium" round @click="lockMessage">
              {{ $t("message.切换锁定") }}
            </el-button>
          </el-link>
          <el-link :underline="false" style="margin-left:240px">
            <el-button size="medium" round @click="sendMessage" type="primary">
              {{ $t("message.发送") }}
            </el-button>
          </el-link>
        </div>
      </div>
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export default {
  name: "messageList",
  components: {
  },
  data() {
    return {
      tableHeight: 500,
      messageList:[],
      // messageList:[{'currentNode':{'id':1,'rootID':1,'state':1,'sort':255,'content':'这是一条测试消息','isAdmin':true,'isShow':false,'userID':'200020','userName':'柚子','avatarUrl':'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic_source%2F9e%2F32%2F9a%2F9e329acc0c79523b0204f6ed7ea1e45e.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1654841242&t=83bba0580755cd78648417c3740fd6a2','forbiddenFlag':true,'createDate':'2022-05-11 12:00:00'}}],
      messageObj:null,
      currentType:0,  //0-全部消息  1-未审核的消息  2-回复管理员的消息
      //聊天信息
      message: {
        content:'',
        rootID:'',
        replyID:'',
        replyUserID:'',
        replyAdmin:false
      },
      appID:188,
      selectedMessage: null,
      selectarr: [{ key: '全部', value: 0 }, { key: '未审核', value: 1 }, { key: '回复我', value: 2 }],
      deleteDialogVisible: false,
      targetRow: null,
      sendData:{
        appID:188,
        filterConfig:{
          keyword:'',
          type:null
        },
        pageConfig:{
          page:1,
          pagesize:0,
          pageStartIndex:0,
          total:0
        },
        sortConfig:{
          order:'',
          prop:''
        }
      }
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    refresh() {
      if(this.message.replyID!==''){
        var oldDiv = document.getElementById(this.message.replyID);
        oldDiv.style.backgroundColor = '';
      }

      this.message.replyID = '';
      this.message.rootID = '';
      this.message.replyUserID = '';
      this.message.replyAdmin = false;

      rejecthttp(true,'post',"/manage/messageboard/getall",this.sendData,this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              console.log(doc.data);
              this.messageObj = doc.data.data;
              if(this.currentType==0){
                this.messageList=doc.data.data.messages;
              }else if(this.currentType==1){
                this.messageList=doc.data.data.examineMessages;
              }else if(this.currentType==2){
                this.messageList=doc.data.data.replyMessages;
              }
            }
            });
    },
    topMessage(){
      if(this.selectedMessage==null)return;
      rejecthttp(true,'get',"/manage/messageboard/top",{
         appid:this.appID,
         id:this.selectedMessage.id,
         type:this.selectedMessage.sort==255?0:1
       },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.refresh();
              this.selectedMessage=null;
            }
            });
    },
    lockMessage(){
      if(this.selectedMessage==null)return;
      rejecthttp(true,'get',"/manage/messageboard/lock",{
         appid:this.appID,
         id:this.selectedMessage.id,
         type:this.selectedMessage.state==3?0:1
       },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.refresh();
              this.selectedMessage=null;
            }
            });
    },
    forbiddenUser(id,flag){
       rejecthttp(true,'get',"/manage/messageboard/forbidden",{
         appid:this.appID,
         userid:id,
         type:flag
       },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.refresh();
            }
            });
    },
    hideMessage(id,flag){
       rejecthttp(true,'get',"/manage/messageboard/hide",{
         appid:this.appID,
         id:id,
         type:flag
       },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.refresh();
            }
            });
    },
    examineMessage(id){
       rejecthttp(true,'get',"/manage/messageboard/examine",{
         appid:this.appID,
         id:id
       },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.refresh();
            }
            });
    },
    selectChanged(value) {
	    if(this.currentType==0){
        this.messageList=this.messageObj.messages;
      }else if(this.currentType==1){
        this.messageList=this.messageObj.examineMessages;
      }else if(this.currentType==2){
        this.messageList=this.messageObj.replyMessages;
      }

      if(this.message.replyID!==''){
        var oldDiv = document.getElementById(this.message.replyID);
        oldDiv.style.backgroundColor = '';
      }

      this.message.replyID = '';
      this.message.rootID = '';
      this.message.replyUserID = '';
      this.message.replyAdmin = false;
      this.selectedMessage=null;
    },
    selectDiv(item){
      console.log(item);
      if(this.message.replyID!==''){
        var oldDiv = document.getElementById(this.message.replyID);
        oldDiv.style.backgroundColor = '';
      }

      if(item.id===this.message.replyID){
        this.message.replyID = '';
        this.message.rootID = '';
        this.message.replyUserID = '';
        this.message.replyAdmin = false;
        this.selectedMessage = null;
      }else{
        var newDiv = document.getElementById(item.id);
        newDiv.style.backgroundColor = '#DDDDDD';

        this.message.replyID = item.id;
        this.message.rootID = item.rootID;
        this.message.replyUserID = item.userID;
        this.message.replyAdmin = item.admin;
        this.selectedMessage = item;
      }
    },
    getDisplayName(bool) {
      return commonUtil.getDisplayName(bool);
    },
    formatDate(date){
      return commonUtil.formatDate(date);
    },
    createTarget() {
      this.$router.push({ name: "articleDetail", query: { appid: "188" } });
    },
    sendMessage() {
      rejecthttp(
        true,
        "post",
        "/manage/messageboard/send?appid="+this.appID,
        this.message,
        this,
        (doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
            this.message.content='';
          }
          this.refresh();
        }
      );
    },

    deleteTarget() {
      rejecthttp(
        true,
        "get",
        "/manage/article/delete",
        {
          appid: 188,
          id: this.targetRow.id,
        },
        this,
        (doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          }
          this.deleteDialogVisible = false;
          this.refresh();
        }
      );
    },
    getMessageStateName(state) {
      return commonUtil.getMessageStateName(state);
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.serachSpan {
  width: 7%;
}
.serachText {
  width: 13%;
}
.serachInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/message/MessageList.vue